// NOTE: this is not always applid to the ListingCard components. It is only
// applied in select situations.
const LISTING_CARD_MAX_WIDTH = 348;

export default LISTING_CARD_MAX_WIDTH;
